import { render, staticRenderFns } from "./playerOrderofMerit.vue?vue&type=template&id=e5923cfe&scoped=true"
import script from "./playerOrderofMerit.vue?vue&type=script&lang=js"
export * from "./playerOrderofMerit.vue?vue&type=script&lang=js"
import style0 from "./playerOrderofMerit.vue?vue&type=style&index=0&id=e5923cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5923cfe",
  null
  
)

export default component.exports